import PatientView from './PatientView.json';
import ViewportDownload from './ViewportDownload.json';

export default {
  hi: {
    PatientView,
    ViewportDownload,
  },
};
